import React, { useRef, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

// Variants to stagger the appearance of the child text elements.
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.5,
    },
  },
};

// First text remains as grey, stays smaller.
const firstTextVariants = {
  hidden: { opacity: 1, fontSize: "1.5rem", color: "grey" },
  visible: {
    opacity: 1,
    fontSize: "2rem",
    color: "grey",
    transition: { duration: 0.7 },
  },
};

// Second text now grows bigger and turns to primary color.
const secondTextVariants = {
  hidden: { opacity: 0, fontSize: "1.5rem", color: "grey" },
  visible: {
    opacity: 1,
    fontSize: "2.5rem",
    color: "#6A5AE0",
    transition: { duration: 0.7 },
  },
};

const ScrollRevealSection = () => {
  const sectionRef = useRef(null);
  const controls = useAnimation();

  useEffect(() => {
    const observerOptions = {
      root: null,
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        controls.start("visible");
      }
    }, observerOptions);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.disconnect();
    };
  }, [controls]);

  return (
    <section
      ref={sectionRef}
      className="min-h-[80vh] sm:min-h-screen flex items-center justify-center bg-white py-8 sm:py-12 md:py-16 px-4 sm:px-6"
    >
      <div className="container mx-auto max-w-4xl text-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={controls}
          className="flex flex-col items-center space-y-3 sm:space-y-4 md:space-y-6"
        >
          <motion.h2
            variants={firstTextVariants}
            className="font-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight sm:leading-snug"
          >
            Exam Prep Is Hard.
            <br className="sm:hidden" /> Unless...
          </motion.h2>
          <motion.h2
            variants={secondTextVariants}
            className="font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight sm:leading-snug"
          >
            You Do It
            <br className="sm:hidden" /> The Fun Way
          </motion.h2>
        </motion.div>
      </div>
    </section>
  );
};

export default ScrollRevealSection;
